import React from "react"
import "./style.scss"
import NewProducts from "../newproducts/index"
// import glassX from "../../../images/glassx.png"
// import discoverX from "../../../images/discoverx.png"
// import dashx from "../../../images/dashx.png"
import product1 from "../../../images/product1.png"
import product2 from "../../../images/product2.png"
import product3 from "../../../images/product3.png"
import product_4 from "../../../images/product_4.png"
import product_5 from "../../../images/product_5.png"
import { Button, useTheme, makeStyles } from "@material-ui/core"
import _ from 'lodash'

const useStyles = makeStyles(theme => ({
  text: {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '19px',
    lineHeight: '30px',
    marginLeft: '10px',
    marginTop: '5px',
    color: '#000000',
    [theme.breakpoints.down(576)]: {
      fontSize: '14px',
    },
  },
  contentBox: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '20px',
  },
  ContentBox: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '20px',
    borderBottom: '2px inset',
  },
  content: {
    paddingLeft: '20px',
    paddingRight: '10px',
  },
  img: {
    width: '60px',
    height: '60px',
  },
  mobContentBox: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '20px',
  },
  mobImg: {
    width: '35px',
    height: '35px',
  },
}))


const ListContent = ({ discoverx, dashx, glassx, reasons }) => {

  const classes = useStyles()
  const theme = useTheme()

  return (
    <div className="listContent">
      <div className="text-area">
        <div>
        {reasons &&
          reasons.map((reason, index) => {
            return (
            <>
            <div className={_.isEqual(reason.title, 'HR Analytics') ? classes.contentBox : classes.ContentBox}>
            {!_.isEmpty(reason?.icon) && <img  src={reason.icon} alt={reason.title} className={classes.img}/>}
            <div className={classes.content}>
              <p className='subtitle' style={{ marginBottom: '10px'}}>{reason.title}</p>
              <p className="text">{reason.description}</p>
            </div>
            </div>
            </>
            )})}
        </div>
      </div>
      <div className="mob-text-area">
        <div>
        {reasons &&
          reasons.map((reason, index) => {
            return (
            <>
            <div className={classes.mobContentBox}>
            <div style={{ display: 'flex' }}>
            {!_.isEmpty(reason?.icon) && <img  src={reason.icon} alt={reason.title} className={classes.mobImg}/>}
              <p className='subtitle' style={{ marginBottom: '10px', marginLeft: '10px' }}>{reason.title}</p>
            </div>
            <p className="text">{reason.description}</p>
            </div>
            </>
            )})}
        </div>
      </div>
    </div>
  )
}

export default ListContent
